import React, { useEffect, useRef } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';

interface SponsorsLottieProps {
  className?: string;
}

export default function SponsorsLottie({ className = '' }: SponsorsLottieProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const lottieRef = useRef<DotLottie | null>(null);

  useEffect(() => {
    if (canvasRef.current) {
      lottieRef.current = new DotLottie({
        autoplay: true,
        loop: true,
        canvas: canvasRef.current,
        src: 'https://lottie.host/f2b0a7cc-4d6a-4b41-af6c-b7585bb1952c/iZp0k0MFgB.lottie'
      });
    }

    return () => {
      if (lottieRef.current) {
        lottieRef.current.destroy();
      }
    };
  }, []);

  return (
    <div className={`relative ${className}`}>
      <canvas 
        ref={canvasRef}
        className="max-w-[300px] mx-auto"
        width="300"
        height="300"
        style={{ width: '300px', height: '300px' }}
      />
    </div>
  );
}